
<template>
  <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
      <span>{{name}}</span>
    </div>
    <div class="text item paramContainer">
        <el-row :gutter="10">
        <el-col class="paramNameCol" :span="8">
            CSS Selector
        </el-col>
        <el-col :span="16">
            <el-input
                placeholder="Please input css selector"
                v-model="model.params.selector"
                clearable>
            </el-input>    
        </el-col>
      </el-row>  
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="8">
            xPATH
        </el-col>
        <el-col :span="16">
            <el-input
                placeholder="Please input xpah"
                v-model="model.params.xpath"
                clearable>
            </el-input>   
        </el-col>
      </el-row>  
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="8">
            Param
        </el-col>
        <el-col :span="16">
            <el-input
                placeholder="Please input xpah"
                v-model="model.params.param"
                clearable>
            </el-input>   
        </el-col>
      </el-row>  
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="8">
            Api key
        </el-col>
        <el-col :span="16">
            <el-input
                placeholder="Please input xpah"
                v-model="model.params.api_key"
                clearable>
            </el-input>   
        </el-col>
      </el-row>  
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="8">
            Remote URL
        </el-col>
        <el-col :span="16">
            <el-input
                placeholder="Please input xpah"
                v-model="model.params.remote_url"
                clearable>
            </el-input>   
        </el-col>
      </el-row>  
      <div class="tip">
          {{desc}}
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'SendContent',
  data () {
    return {
      name: 'SendContent',
      desc: '',
    }
  }, 
  props: {
      model: {
          type: Object,
          default: () => {}
      },
  },
  methods: {
   
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading',
    }),
  },
}
</script>

<style lang="scss" scoped>

</style>
